import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { PlanListFilerActionTypes, PlanListFilerActions } from '../actions/plan-list-filer.actions';


@Injectable()
export class PlanListFilerEffects {
  private actions$ = inject(Actions);
  loadPlanListFilers$ = createEffect(() => this.actions$.pipe(
    ofType(PlanListFilerActionTypes.LoadPlanListFilers),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
